import React, { useState, useEffect } from "react";
import AllAbove from "../../shared/allInterests/allAbove";
import Travel from "../../shared/allInterests/travel";
import Books from "../../shared/allInterests/Books";
import Other from "../../shared/allInterests/Other";
import FB from "../../shared/allInterests/FB";
import Shoes from "../../shared/allInterests/Shoes";
import Relation from "../../shared/allInterests/Relation";

// Mapping interest names to numeric codes
const interestCodes = {
  travel: 30,
  other: 31,
  relationships: 33,
  taboo: 34,
  fAndB: 35,
  inTheShoesOf: 36,
  Books: 10,
};

const InterestInput = ({ selectedInterests, onInterestsChange }) => {
  const [isOpenToAll, setIsOpenToAll] = useState(false);

  // Initialize checkbox state based on selected interests
  const [checkboxState, setCheckboxState] = useState({
    travel: false,
    other: false,
    relationships: false,
    taboo: false,
    fAndB: false,
    inTheShoesOf: false,
    Books: false,
  });

  // Sync initial checkbox state with selected interests
  useEffect(() => {
    const initialState = Object.keys(interestCodes).reduce((state, key) => {
      state[key] = selectedInterests?.includes(interestCodes[key]);
      return state;
    }, {});
    setCheckboxState(initialState);
  }, [selectedInterests]);

  useEffect(() => {
    const allTrue = Object.values(checkboxState).every(
      (value) => value === true
    );
    setIsOpenToAll(allTrue);
  }, [checkboxState]);

  const handleOpenToAllChange = (e) => {
    const isChecked = e.target.checked;
    setIsOpenToAll(isChecked);

    const updatedCheckboxState = Object.keys(checkboxState).reduce(
      (state, key) => {
        state[key] = isChecked;
        return state;
      },
      {}
    );

    setCheckboxState(updatedCheckboxState);

    // Update interests in the parent component
    const updatedInterests = isChecked ? Object.values(interestCodes) : [];
    onInterestsChange(updatedInterests);
  };

  const handleCheckboxChange = (key) => (e) => {
    const isChecked = e.target.checked;

    setCheckboxState((prevState) => {
      const updatedState = { ...prevState, [key]: isChecked };

      // Update interests in the parent component
      const updatedInterests = Object.keys(updatedState)
        .filter((key) => updatedState[key]) // Get checked interests
        .map((key) => interestCodes[key]);

      onInterestsChange(updatedInterests);

      // Update "Open to All" state
      const allChecked = Object.values(updatedState).every((value) => value);
      setIsOpenToAll(allChecked);

      return updatedState;
    });
  };
  return (
    <div>
      <div className="multiple-check-box">
        <label htmlFor="email" className="ms-input-label">
          Interests
        </label>
        <div className="ms-pill-wrap">
          <AllAbove
            isOpenToAll={isOpenToAll}
            handleOpenToAllChange={handleOpenToAllChange}
          />
          <Travel
            checkboxState={checkboxState}
            handleCheckboxChange={handleCheckboxChange}
          />
          <Relation
            checkboxState={checkboxState}
            handleCheckboxChange={handleCheckboxChange}
          />
          <Books
            checkboxState={checkboxState}
            handleCheckboxChange={handleCheckboxChange}
          />
          <FB
            checkboxState={checkboxState}
            handleCheckboxChange={handleCheckboxChange}
          />
          <Shoes
            checkboxState={checkboxState}
            handleCheckboxChange={handleCheckboxChange}
          />
          <Other
            checkboxState={checkboxState}
            handleCheckboxChange={handleCheckboxChange}
          />
        </div>
        <div className="ms-how-drawer for-radio">
          <div className="ms-drawer-contain">
            <div className="ms-embed w-embed">
              Custom CSS
              <style
                dangerouslySetInnerHTML={{
                  __html:
                    "\n                        .ms-pill-checkbox:checked~.ms-pill-label.has-icon {\n                          background-color: #e2b760;\n                          border-color: #e2b760;\n                          color: #1a1a1a;\n                          padding-left: 35px;\n                        }\n                        .ms-pill-checkbox:checked~.ms-pill-icon {\n                          display: flex;\n                        }\n                      ",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterestInput;
